import { render, staticRenderFns } from "./signList.vue?vue&type=template&id=4a489664"
import script from "./signList.vue?vue&type=script&lang=js"
export * from "./signList.vue?vue&type=script&lang=js"
import style0 from "./signList.vue?vue&type=style&index=0&id=4a489664&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports